import React from "react";

const AboutPage = () => {
  return (
    <div className="text-gray-800 text-center">
      <h2 className="text-4xl font-bold mb-4">About Me</h2>
      <p className="text-xl mb-6">[Your brief introduction]</p>
      <ul>
        <li>
          I specialise in web development, particularly in building responsive
          and user-friendly web applications.
        </li>
        <li>My journey began with [your story or experience]...</li>
      </ul>
    </div>
  );
};

export default AboutPage;
